<template>
    <component
        :is="element"
        :to="!external && uri ? uri : null"
        :href="external && uri ? uri : null"
        :external="external"
        class="card"
        :class="{
            'card--no-header': !$slots.header
        }"
        :style="{
            cursor: uri ? 'pointer' : 'default'
        }"
    >
        <template v-if="$slots.badge">
            <slot name="badge" />
        </template>
        <header
            v-if="$slots.header"
            class="card__header"
        >
            <slot name="header" />
        </header>
        <h4 class="card__title">
            <slot name="title" />
        </h4>
        <div class="card__meta">
            <slot name="meta" />
        </div>
        <div class="card__footer">
            <slot name="footer" />
        </div>
    </component>
</template>

<script setup>
const { checkIsExternal } = useUri();

const props = defineProps({
    uri: {
        type: String,
        required: false,
        default: null
    },
    external: {
        type: Boolean,
        required: false,
        default: false
    }
});

const element = computed(() => {
    if (!props.uri) {
        return 'article';
    }
    if (checkIsExternal(props.uri)) {
        return 'a';
    }
    return resolveComponent('NuxtLink');
});
</script>

<style lang="less" src="./BaseCard.less" />
